module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jC6fZ"))).then(() => parcelRequire('ljYL6'));